import React, { useState, Component, Fragment } from "react"
import { accessRole } from "../../../../../../helpers/access_role"
import { config } from "../../../../../../helpers/config_global"
import { Redirect } from "react-router-dom"

import {
    Container,
    Row, Col,Tooltip,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,Badge,
} from "reactstrap"
import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/homeService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../../services/apiResponse'

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};


class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historyHomeKepegawaianCutiTableActive'
    defaultOrder = 'paid_leave_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            revokeUuid: null,
            saldoUuid: null,
            approveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            loading: false,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            date_start: this.props.filter?.dateStart,
            date_end: this.props.filter?.dateEnd,
            paid_leave_type_uuid: this.props.filter?.paid_leave_type_uuid,
            approval_status: this.props.filter?.status
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }
    loadRekap = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            date_start: this.props.filter?.dateStart,
            date_end: this.props.filter?.dateEnd,
            paid_leave_type_uuid: this.props.filter?.paid_leave_type_uuid,
            approval_status: this.props.filter?.status
        }
        await this.dataTableBloc.fetchRekap(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }
    setTokenAPIRekap = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadRekap()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    handleButtonRekapCuti = () => {
        this.dataTableBloc.fetchRekapCuti();
        console.log(this.state.filter)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        if (this.props.filter) {
            this.setTokenAPI()
        }

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.rekapChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loading: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loading: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    // alert(link.file_url)
                    this.setState({
                        loading: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.rekapCutiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.filter !== this.props.filter) {
    //         this.loadData()
    //     }
    // }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
        this.dataTableBloc.inactiveChannel?.unsubscribe()
    }

    columns = [
        {
            key: "paid_leave_employee_full_name",
            text: "Pegawai",
        },
        {
            key: "paid_leave_type_full_name",
            text: "Jenis Cuti",
        },
        {
            key: "paid_leave_create_date",
            text: "Tanggal Pengajuan",
            sortable: true,
            // width: '20%', 
            cell: record => {
                return reformatDate(record.paid_leave_create_date)
            }
        },
        {
            key: "paid_leave_start_date",
            text: "Mulai Cuti",
            sortable: true,
            width: '20%',
            cell: record => {
                return reformatDate(record.paid_leave_start_date)
            }
        },
        {
            key: "paid_leave_end_date",
            text: "Selesai Cuti",
            sortable: true,
            width: '20%', 
            cell: record => {
                return reformatDate(record.paid_leave_end_date)
            }
        },
        {
            key: "paid_leave_count",
            text: "Lama Hari Cuti",
            align: 'center',
        },
        {
            key: "paid_leave_approval_status",
            text: "Status",
            sortable: false,
            cell: record => {
                let color = 'info'
                if (record.paid_leave_approval_status === 1) {
                    color = 'success'
                } else if (record.paid_leave_approval_status === 2) {
                    color = 'warning'
                } else if (record.paid_leave_approval_status === 3) {
                    color = 'danger'
                } else if (record.paid_leave_approval_status === 4) {
                    color = 'danger'
                }
                return (
                    <Fragment>
                        <Label className={`badge rounded-pill bg-soft-${color} font-size-12`}>{record.paid_leave_approval_status_name}</Label>
                    </Fragment>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.paid_leave_id
                return (
                    <Fragment>
                        { record.paid_leave_approval_status === 0  && 
                            <Fragment>
                                {accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    approveUuid: record.paid_leave_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-check"></i>
                                        </button>
                                    </span>
                                }
                            </Fragment>
                        }
                        { record.paid_leave_approval_status === 3 &&
                            <Fragment>
                                {accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            id={"revoke-"+thisId}
                                            onClick={() => {
                                                this.setState({
                                                    revokeUuid: record.paid_leave_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-user-times"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["revoke" + thisId]} target={"revoke-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["revoke" + thisId] : !this.state["revoke" + thisId]
                                                })
                                            }}
                                        >Approve Pembatalan</Tooltip>
                                    </span>
                                }                               
                            </Fragment>
                        }
                        { accessRole('update') &&
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.paid_leave_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId] : !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span>
                        }
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.paid_leave_uuid
                                    })
                                    
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat Detail</Tooltip>
                            {/* <span>
                                <button
                                    className="btn btn-info btn-sm"
                                    id={"saldo-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            saldoUuid: record.paid_leave_employee_uuid
                                        })
                                        
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-calculator-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["saldo" + thisId]} target={"saldo-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["saldo" + thisId] : !this.state["saldo" + thisId]
                                        })
                                    }}
                                >Lihat Saldo Cuti</Tooltip>
                            </span> */}
                        </span>
                        { accessRole('delete') &&
                                    <span>
                                        <button 
                                            className="btn btn-danger btn-sm" 
                                            id={"delete-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    inactiveUuid: record.paid_leave_uuid,
                                                    confirm: true
                                                })
                                            }}
                                            style={{
                                                padding: '2px 5px'
                                            }}>
                                            <i className="uil-trash-alt"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["delete" + thisId] : !this.state["delete" + thisId]
                                                })
                                            }}
                                        >Batalkan</Tooltip>
                                    </span>
                                }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                {/* <div className="d-flex mb-3">
                    
                    <div className="ms-auto">
                        
                        <Button 
                            color="warning" 
                            type="button"
                            onClick={() => {
                                this.handleButtonRekapCuti()
                            }}
                        >
                            <i className="uil-file-download"></i> Rekap Cuti
                        </Button>
                    </div>
                </div> */}
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.approveUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?approve&uuid=${this.state.approveUuid}`}/>
                : null }
                { this.state.detailUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?detail&uuid=${this.state.detailUuid}`}/>
                : null }
                { this.state.revokeUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?revoke&uuid=${this.state.revokeUuid}`}/>
                : null }
                { this.state.saldoUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?saldo&uuid=${this.state.saldoUuid}`}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={`/izinpegawai/cuti.html?update&uuid=${this.state.updateUuid}`}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent